import GradeSync from './GradeSync';

export default GradeSync;
